import {put, takeEvery, select, delay} from 'redux-saga/effects';
import {getOrderDates, getOrderTimeSlots} from 'new-actions/api.actions.ts';

import {SET_PICKER_DATE} from 'new-constants/order-time.constants';
import {getCartTotal} from 'helpers/purchase.helper.ts';
import {getCartItems} from 'helpers/order-line.helper.ts';
import {
	getCurrentDeliveryAddressSelector,
	getCurrentMenuSelector,
	getCurrentOrderLinesSelector,
	getCurrentPurchaseSelector,
	getCurrentRestaurantIdSelector, getCurrentRestaurantSelector,
	getCurrentServerValuesSelector,
	getDeliveryConditionsSelector, getTipAmountSelector,
} from '../selectors';
import {CHECKOUT} from 'new-constants/navigation.constants';
import {OrderingTypes} from 'new-constants/common.constants';
import {START} from "../constants/app-state.constants";
import {isNotPossibleToChooseTime} from "../helpers/restaurant.helper";
import {REPEAT_ORDER_SUCCESS} from "../constants/api.constants";

function* loadTimeSlots(action) {
	const state = yield select();

	const currentRestaurantId = getCurrentRestaurantIdSelector(state);

	if (!currentRestaurantId) return null;

	const currentPurchase = getCurrentPurchaseSelector(state);
	const currentOrderLines = getCurrentOrderLinesSelector(state);
	const currentMenu = getCurrentMenuSelector(state);
	const currentDeliveryAddress = getCurrentDeliveryAddressSelector(state);

	yield put(
		getOrderTimeSlots(
			currentRestaurantId,
			getCartTotal(
				currentPurchase,
				getCurrentServerValuesSelector(state),
				getDeliveryConditionsSelector(state),
				getCartItems(currentOrderLines, currentMenu),
				getTipAmountSelector(state)
			),
			action.date,
			currentDeliveryAddress?.zip
		)
	);
}

function* loadDateSlots() {
	const state = yield select();

	yield delay(1000);

	const currentRestaurantId = getCurrentRestaurantIdSelector(state);
	const currentPurchase = getCurrentPurchaseSelector(state);
	const currentOrderLines = getCurrentOrderLinesSelector(state);
	const currentMenu = getCurrentMenuSelector(state);
	const deliveryConditions = getDeliveryConditionsSelector(state);
	const currentDeliveryAddress = getCurrentDeliveryAddressSelector(state);

	yield put(
		getOrderDates(
			currentRestaurantId,
			getCartTotal(
				currentPurchase,
				getCurrentServerValuesSelector(state),
				deliveryConditions,
				getCartItems(currentOrderLines, currentMenu),
				getTipAmountSelector(state)
			),
			state.orderTime.pickupDate,
			currentDeliveryAddress?.zip
		)
	);
}

function* refreshDateSlotsIfEmpty() {
	yield delay(3000);

	const state = yield select();
	const currentRestaurant = getCurrentRestaurantSelector(state);

	if (isNotPossibleToChooseTime(currentRestaurant, state.orderTime)) {
		yield loadDateSlots();
	}
}

export const orderTimeSaga = function* orderTimeSaga() {
	yield takeEvery([SET_PICKER_DATE], loadTimeSlots);
	yield takeEvery([CHECKOUT, REPEAT_ORDER_SUCCESS], loadDateSlots);
	yield takeEvery([START], refreshDateSlotsIfEmpty)
};
